import { takeLatest, call, put, all } from 'redux-saga/effects';

import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_EDUCACAO_SEDUC_DOMINIOS_API } from 'services/rotasp/path';
import { ReducerActionRotaSP } from 'store/modules/types';
import { comboUfSuccess, comboUfFailure } from './actions';
import { Types } from './types';

function* ComboUfRequest(request: ReducerActionRotaSP) {
	const { token } = request;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_EDUCACAO_SEDUC_DOMINIOS_API,
		`ufs`,
	);
	if (response.status === 200) {
		yield put(comboUfSuccess(response));
	} else {
		yield put(comboUfFailure(response.data));
	}
}

export default all([takeLatest(Types.COMBO_UF_REQUEST, ComboUfRequest)]);
